import { useQuery } from '@tanstack/react-query'
import { fetchBMData } from './fetchBMData'
import { SummaryData, NormalizedSummaryData } from './BMDataTypes'

export const useSummaryQuery = (
  networkIdEnc: string,
  fromDate: string,
  toDate: string,
  domainsParam: string[]
) => {
  const { data, ...queryDetails } = useQuery<SummaryData>({
    queryKey: ['summary', networkIdEnc, fromDate, toDate, domainsParam.join(',')],
    queryFn: () =>
      fetchBMData<SummaryData>('summary', networkIdEnc, {
        params: {
          limit: 300,
          offset: 0,
          'from-date': fromDate,
          'to-date': toDate,
          last3months: false,
          group: '',
          domains: domainsParam,
          search: '',
        },
      }),
  })

  const summary: NormalizedSummaryData = {
    rawData: data,
    summaryEntries: data?.summary?.summary || [],
    isLoading: queryDetails.isLoading,
    isError: queryDetails.isError,
    error: queryDetails.error,
  }

  return { summary, ...queryDetails }
}
